// Carry Roll Hazard check — carry vs hazard yardage (10.3). Pure function.
/** Check whether carry clears a hazard at the given distance. */
export function hazardCheck(carryM, hazardM) {
    const marginM = carryM - hazardM;
    return {
        pass: marginM > 0,
        marginM,
    };
}
/**
 * Check whether the flight path clears an obstacle of `obstacleHeightM` at
 * `obstacleM` downrange. Linearly interpolates the trajectory height at that
 * downrange distance. `pass` when the interpolated height exceeds the obstacle;
 * `clearanceM` is the height difference.
 */
export function obstacleCheck(flightPath, obstacleM, obstacleHeightM) {
    const fail = { pass: false, clearanceM: -obstacleHeightM };
    if (flightPath.length === 0) {
        return fail;
    }
    const first = flightPath[0];
    const last = flightPath[flightPath.length - 1];
    // Single point: evaluate directly.
    if (flightPath.length === 1) {
        const h = first.y;
        return { pass: h > obstacleHeightM, clearanceM: h - obstacleHeightM };
    }
    // Before the first sample or after the last: clamp to the nearest endpoint height.
    if (obstacleM <= first.x) {
        const h = first.y;
        return { pass: h > obstacleHeightM, clearanceM: h - obstacleHeightM };
    }
    if (obstacleM >= last.x) {
        const h = last.y;
        return { pass: h > obstacleHeightM, clearanceM: h - obstacleHeightM };
    }
    // Find the bracketing pair and linearly interpolate.
    for (let i = 0; i < flightPath.length - 1; i++) {
        const a = flightPath[i];
        const b = flightPath[i + 1];
        if (obstacleM >= a.x && obstacleM <= b.x) {
            const span = b.x - a.x;
            const t = span !== 0 ? (obstacleM - a.x) / span : 0;
            const h = a.y + t * (b.y - a.y);
            return { pass: h > obstacleHeightM, clearanceM: h - obstacleHeightM };
        }
    }
    // Fallback (should not reach here).
    const h = last.y;
    return { pass: h > obstacleHeightM, clearanceM: h - obstacleHeightM };
}
//# sourceMappingURL=hazard.js.map